import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AccommodationLabelOptionsPipe } from '../../pipes/accommodation-label-options/accommodation-label-options.pipe';
import { Accommodation } from '../../types';

@Component({
  standalone: true,
  selector: 'lx-accommodation-options',
  templateUrl: './accommodation-options.component.html',
  styleUrls: ['./accommodation-options.component.scss'],
  imports: [AccommodationLabelOptionsPipe],
})
export class AccommodationOptionsComponent implements OnChanges {
  @Input() accommodation: Accommodation | undefined;

  /**
   * Show the extended accommodation info
   */
  @Input() extended = false;

  roomType: string | undefined;
  bathroomType: string | undefined;
  mealOptions: string | undefined;

  ngOnChanges({ accommodation }: SimpleChanges): void {
    if (this.extended && accommodation?.currentValue) {
      const groupedItems = accommodation?.currentValue?.groupedItems || [];
      this.roomType = [...new Set(groupedItems.map(({ roomType }) => roomType))]?.join(', ');
      this.bathroomType = [...new Set(groupedItems.map(({ bathroomType }) => bathroomType))]?.join(', ');
      this.mealOptions = [...new Set(groupedItems.map(({ mealOptions }) => mealOptions))]?.join(', ');
    } else {
      const { roomType, bathroomType, mealOptions } = accommodation?.currentValue || {};
      this.roomType = roomType;
      this.bathroomType = bathroomType;
      this.mealOptions = mealOptions;
    }
  }
}
